import { ColumnDef } from '@tanstack/react-table';
// import { Badge } from 'components/ui/badge';
import { DataTableColumnHeader } from '../../../../components/blocks/data-table/data-table-column-header';
import { OrganizationData } from '../../services/organization-service';
import { DataTableRowActions } from './organization-table-row-actions';

/* type StatusOption = {
    value: boolean;
    label: string;
    color: 'success' | 'error';
}; */

/* const getOrganizationStatuses = (t: (key: string) => string): StatusOption[] => [
    { value: true, label: t('ACTIVE'), color: 'success' },
    { value: false, label: t('INACTIVE'), color: 'error' },
]; */

interface ColumnFactoryProps {
    onViewDetails: (org: OrganizationData) => void;
    onEdit: (org: OrganizationData) => void;
    onDeactivate?: (org: OrganizationData) => void;
    onActivate?: (org: OrganizationData) => void;
    t: (key: string) => string;
}

export const createOrganizationTableColumns = ({
    onViewDetails,
    onDeactivate,
    onActivate,
    t
}: ColumnFactoryProps): ColumnDef<OrganizationData, any>[] => [
        {
            id: 'name',
            header: ({ column }) => <DataTableColumnHeader column={column} title={t('NAME')} />,
            accessorFn: (row) => row.name,
            cell: ({ row }) => {
                return (
                    <div className="flex items-center">
                        <span className="max-w-[300px] truncate font-medium">{row.original.name}</span>
                    </div>
                );
            },
        },
        {
            id: 'email',
            header: ({ column }) => <DataTableColumnHeader column={column} title={t('EMAIL')} />,
            accessorFn: (row) => row.email,
            cell: ({ row }) => (
                <div className="flex items-center">
                    <span className="max-w-[250px] truncate">{row.original.email}</span>
                </div>
            ),
        },
        {
            id: 'phoneNumber',
            header: ({ column }) => <DataTableColumnHeader column={column} title={t('MOBILE_NO')} />,
            accessorFn: (row) => row.phoneNumber,
            cell: ({ row }) => (
                <div className="flex items-center">
                    <span className="max-w-[150px] truncate">{row.original.phoneNumber || '-'}</span>
                </div>
            ),
        },
        /* {
            id: 'isActive',
            accessorFn: (row) => row.isActive,
            header: ({ column }) => <DataTableColumnHeader column={column} title={t('STATUS')} />,
            cell: ({ row }) => {
                const status = getOrganizationStatuses(t).find(
                    (status) => status.value === row.original.isActive
                );
                if (!status) return null;
                return (
                    <div className="flex items-center">
                        <Badge
                            variant="outline"
                            className={status.color === 'success' ? 'text-success' : 'text-error'}
                        >
                            {status.label}
                        </Badge>
                    </div>
                );
            },
            filterFn: (row, id, value: string[]) => {
                if (value.length === 0) return true;
                const cellValue = row.getValue(id) as boolean;
                return value.includes(cellValue.toString());
            },
        }, */
        {
            id: 'createdDate',
            accessorFn: (row) => row.createdDate,
            header: ({ column }) => <DataTableColumnHeader column={column} title={t('CREATED_ON')} />,
            cell: ({ row }) => {
                const date = new Date(row.original.createdDate);
                return (
                    <div className="flex items-center">
                        <span>
                            {new Date(date)
                                .toLocaleDateString('de-CH', {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric',
                                })
                                .split('/')
                                .join('/')}
                        </span>
                    </div>
                );
            },
            sortingFn: (rowA, rowB) => {
                const a = new Date(rowA.original.createdDate).getTime();
                const b = new Date(rowB.original.createdDate).getTime();
                return a < b ? -1 : a > b ? 1 : 0;
            },
            filterFn: (row, id, value) => {
                if (!value?.from || !value?.to) return true;
                const rowDate = new Date(row.getValue(id));
                console.log('Filter values in UTC:', {
                    from: value.from.toISOString(),
                    to: value.to.toISOString(),
                    rowDate: rowDate.toISOString(),
                    rowValue: row.getValue(id)
                });
                return rowDate >= value.from && rowDate <= value.to;
            },
        },
        {
            id: 'lastUpdatedDate',
            accessorFn: (row) => row.lastUpdatedDate,
            header: ({ column }) => <DataTableColumnHeader column={column} title={t('LAST_UPDATED')} />,
            cell: ({ row }) => {
                const date = new Date(row.original.lastUpdatedDate);
                return (
                    <div className="flex items-center">
                        <span>
                            {new Date(date)
                                .toLocaleDateString('de-CH', {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric',
                                })
                                .split('/')
                                .join('/')}
                        </span>
                    </div>
                );
            },
            sortingFn: (rowA, rowB) => {
                const a = new Date(rowA.original.lastUpdatedDate).getTime();
                const b = new Date(rowB.original.lastUpdatedDate).getTime();
                return a < b ? -1 : a > b ? 1 : 0;
            },
        },
        {
            id: 'actions',
            cell: ({ row }) => (
                <DataTableRowActions
                    row={row}
                    onViewDetails={onViewDetails}
                    onDeactivate={onDeactivate}
                    onActivate={onActivate}
                />
            ),
        },
    ]; 